<template>
  <v-layout row wrap>
    <v-flex xs12 md8>
      <h2 class="display-1 mb-3">Approval limits</h2>
    </v-flex>
    <v-flex xs12 md8>
      <router-view></router-view>
    </v-flex>
  </v-layout>
</template>

<script>
export default {
  name: 'limit'
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/approval-limit/Limit.vue